import { create } from "zustand"

interface Store {
  isLoading: boolean
  setIsLoading: (isLoading: boolean) => void
}

export const useAppStateStore = create<Store>()(set => ({
  isLoading: false,
  setIsLoading: (isLoading: boolean) => set({ isLoading }),
}))
